import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-paiqi",
  "use": "icon-icon-paiqi-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon-paiqi\">\r\n<g id=\"icon-icon-paiqi_icon-&#230;&#142;&#146;&#230;&#156;&#159;&#231;&#174;&#161;&#231;&#144;&#134;\">\r\n<path id=\"icon-icon-paiqi_Union\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M6 0H4V1H1H0V2V12C0 14.2091 1.79086 16 4 16H15H16V15V2V1H15H12V0H10V1H6V0ZM10 3V2H6V3H4V2H1V6H15V2H12V3H10ZM15 7H1V12C1 13.6569 2.34315 15 4 15H15V7Z\" fill=\"#555555\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol